module.exports = __webpack_public_path__ + "static/mcfly-e00963e4016701ea4dc2471d095e60fa.jpg";